import axios from "axios";
import { ITopElement } from "backend/model/model";
import { useAppContext } from "qpr-base/context/AppCtxProvider";
import { useQuery } from "react-query";

const useTopElements = () => {
  const ctx = useAppContext();

  return useQuery<ITopElement[]>(
    `use-topelements-${ctx.modelId}`,
    async () => {
      try {
        const response = await axios.get(
          `/workflow/topelements/SC.${ctx.modelId}`,
          {}
        );

        const rows = response.data?.data;
        if (!Array.isArray(rows)) return [];

        return rows.map((topelement: any) => {
          topelement.JS_ATTR = topelement.translations || "";
          delete topelement.translations;
          return topelement;
        });
      } catch {
        // MEA often returns 400 "Incorrect query" for topelements; treat as empty so pages
        // (e.g. workflow input) are not stuck behind a global loader or error state.
        return [];
      }
    },
    {
      enabled: !!ctx.modelId,
      staleTime: 30 * 60 * 1000, // cache result
      retry: false, // Don't retry if model doesn't exist
      refetchOnWindowFocus: false,
      refetchOnMount: false,
    }
  );
};

export default useTopElements;
